// Firebase SDK'yı içe aktarın
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase yapılandırma bilgilerinizi buraya ekleyin
const firebaseConfig = {
    piKey: "AIzaSyCHo3Wps6dFUDIb_UACz4fhsYNu3dhFThQ",
    authDomain: "dunyamizinkaderiellerimizde.firebaseapp.com",
    projectId: "dunyamizinkaderiellerimizde",
    storageBucket: "dunyamizinkaderiellerimizde.firebasestorage.app",
    messagingSenderId: "1031810545921",
    appId: "1:1031810545921:web:4309120b144134805cc300",
    measurementId: "G-PCHLQN013X"
};

// Firebase'i başlatın
const app = initializeApp(firebaseConfig);

// Firestore ve Storage'ı dışa aktarın
export const firestore = getFirestore(app);
export const storage = getStorage(app);


